import styled from 'styled-components';

// Over the cube's square, which the canvas draws; empty space in it still reaches the canvas.
export const CubeOverlay = styled.div<{ $size: number; $margin: number }>`
  position: absolute;
  top: ${(p) => p.$margin}px;
  right: ${(p) => p.$margin}px;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  z-index: 3;
  pointer-events: none;
`;

export const CubeButton = styled.div<{ $corner: 'top-left' | 'bottom-right'; $shown: boolean }>`
  position: absolute;
  ${(p) => (p.$corner === 'top-left' ? 'top: 14%; left: 14%;' : 'bottom: 14%; right: 14%;')}
  opacity: ${(p) => (p.$shown ? 1 : 0)};
  transition: opacity 160ms ease;
  pointer-events: ${(p) => (p.$shown ? 'auto' : 'none')};
`;
